import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {AppConfigService} from "../../../services/app-config.service";
import {SessionNames} from "../../../shared/session/session-names";
import {CrystalClearFrontUrlTools} from "../../../shared/pages/crystal-clear-front-url-tools";
import {PageDescription} from "../../../shared/pages/page-description";
import {CCRolesType} from "../../../model/security/cc-roles-type";
import {CrystalClearFrontUrlSupport} from "../../../shared/pages/crystal-clear-front-url-support";

@Component({
  selector: 'app-support-sidebar',
  templateUrl: './support-sidebar.component.html',
  styleUrls: ['./support-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SupportSidebarComponent implements OnInit {

  sidebarToggledChange: boolean = true;

  transPartKey: string = 'page.customer';

  menuItemsTop: MenuItem[] = [];
  menuItemsBottom: MenuItem[] = [];

  constructor(public router: Router,
              private appConfigService: AppConfigService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    //load from cookies
    // if (this.cookieService.check(CookieNames.MENU_SIDE_BAR_MAXIMIZED)) {
    //   if (this.cookieService.get(CookieNames.MENU_SIDE_BAR_MAXIMIZED) === 'true') {
    //     this.sidebarToggledChange = true;
    //   }
    // }
    const roles = JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES));
    if (roles) {
      this.menuItemsTop = [
        this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_SYNC, roles, false),
        this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_TRADE, roles, false),
        this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_ORDER, roles, false),
        this.toMenuItem(CrystalClearFrontUrlSupport.SUPPORT_CLEARING, roles, false),
      ];
    }
  }

  SizeChanged($event) {
    // this.cookieService.set(CookieNames.MENU_SIDE_BAR_MAXIMIZED, $event);
  }

  private toMenuItem(pDesc: PageDescription, roles: CCRolesType.Roles[], iconOnly: boolean, subItems: MenuItem[] = []): MenuItem {
    return PageDescription.toMenuItem({
        path: pDesc.path,
        label: pDesc.label,
        icon: undefined,
        roles: pDesc.roles
      }, this.translateService,
      this.router, roles, iconOnly, subItems);
  }
}
